import { useCachedApiCall } from '@hooks/apiCall';
import { orgEmployeesCache } from './orgEmployeeStore';

/*
 * Thin cache-backed bindings so hooks and features don't hand-roll
 * param arrays. See docs/api-caching.md §8 for the hook contract.
 */

/** Cache-backed list of all employees of an organization. */
export const useAllOrgEmployeesEntry = (orgId?: string) =>
    useCachedApiCall(orgEmployeesCache, [orgId]);
